import React, {Component} from 'react'
import {Button, Row, Col, Tabs, message, Popconfirm} from 'antd';
import {Redirect, Switch, Route, withRouter} from 'react-router-dom'
import './index.less'
import OrderTrack from "./order-track";
import OrderFile from "./order-file";
import {getOrder, getOrderDelivery, reqReview, reqBoxComplete} from '../../api'
import authorizePage from "../../components/authorize/authorizePage";
import authorizeBase from "../../components/authorize/authorizeBase";
import OrderBoxFile from "./order-box-file";
import OrderDeclare from './order-declare';
import OrderShortInfoView from './order-short-info-v'
const AuthButton = authorizeBase(Button)
const {TabPane} = Tabs;

let orderId = '';
class OrderInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: {},
            boxInfo: {},
        }
    }

    componentWillMount() {
        sessionStorage.removeItem("track");
        sessionStorage.removeItem("space");
        sessionStorage.removeItem("invoice");
    }

    componentDidMount() {
        if (this.props.location.state) {
            orderId = this.props.location.state.orderId;
            this.getOrderShortFunc(orderId);
            this.getOrderDeliveryFunc(orderId);
        }
    }

    judgeReadOnly = orderStatus => {
        if (orderStatus == 'audit' || orderStatus == 'audited') {
            return true;
        }
        return false;
    };
    callback = (key) => {
        this.props.history.push(key, {orderId: orderId})
    }
    getOrderShortFunc = async (id) => {
        let result = await getOrder(id)
        if (result.code === 200) {
            var data = result.data;
            this.setState({order: data, readOnly: this.judgeReadOnly(data.orderStatus)})

        } else {
            message.error(result.message)
        }
    }

    getOrderDeliveryFunc = async (id) => {
        let result = await getOrderDelivery(id);
        if (result.code === 200) {
            if (result.data && result.data.length > 0) {
                this.setState({boxInfo: result.data[0], mapData: result.data,});
            } else {
                this.setState({boxInfo: {}});
            }
        } else {
            message.error(result.message)
        }
    };

    approveOrder = async () => {
        orderId = this.props.location.state.orderId;
        const type = 1
        let result = await reqReview(orderId, type)
        if (result.code === 200) {
            this.props.history.replace('/trackList')
        } else if (result.code === 204) {
            message.error(result.message)
        } else {
            message.error(result.message)
        }
    }

    rejectOrder = async () => {
        orderId = this.props.location.state.orderId;
        const type = 0
        let result = await reqReview(orderId, type)
        if (result.code === 200) {
            this.props.history.replace('/orderList')
        } else if (result.code === 204) {
            message.error(result.message)
        } else {
            message.error(result.message)
        }
    }

    handleComplete = async () => {
        let result = await reqBoxComplete(orderId)
        if (result.code === 200) {
            this.props.history.replace('/orderList')
        } else if (result.code === 204) {
            message.error(result.message)
        } else {
            message.error(result.message)
        }
    }

    render() {
        const {order, boxInfo} = this.state;
        const path = this.props.location.pathname;
        return (
            <div className='order-info box-shadow padding-20'>
                <div className="head-title">
                    <div className='flex-between'>
                        <span className='title' style={{lineHeight: '32px'}}>订单详情</span>
                        {order.orderStatus != 'failed' && order.orderStatus != 'new' ?
                            <AuthButton authority="order_edit:complete_box" type='primary' style={{float: 'right'}}
                                        onClick={this.handleComplete}>完成装箱</AuthButton> : ''}
                    </div>
                </div>
                <OrderShortInfoView order={order}/>
                <div className='order-info-tab'>
                    <Tabs type="card" tabBarGutter={'16'} onChange={this.callback}
                          defaultActiveKey={path}>
                        <TabPane tab="委托单" key="/trackEdit/track"></TabPane>
                        <TabPane tab="装车照片" key="/trackEdit/file" disabled={this.state.readOnly}></TabPane>
                        <TabPane tab="资料文件" key="/trackEdit/box-file" disabled={this.state.readOnly}></TabPane>
                        {/*<TabPane tab="报关单" key="/trackEdit/declare"></TabPane>*/}
                    </Tabs>
                </div>
                <div className='order-info-content'>
                    <Switch>
                        <Route path='/trackEdit/track' component={OrderTrack}/>
                        <Route path='/trackEdit/file' render={(props) =>
                            <OrderFile {...props} deliveryType={order.deliveryType} subType={order.subType}
                                       volume={order.volume} boxInfo={boxInfo}/>}/>
                        <Route path='/trackEdit/box-file' render={(props) =>
                            <OrderBoxFile {...props} readonly={true} deliveryType={order.deliveryType}
                                          boxWeightData={{
                                              cabinetCode: order.cabinetCode,
                                              dskNo: order.dskNo,
                                              dskDt: order.dskDt,
                                              atbDt: order.atbDt
                                          } }/>}/>
                        <Route path='/trackEdit/declare' component={OrderDeclare}/>
                        <Route component={OrderTrack}/>
                    </Switch>
                </div>

            </div>
        )

    }
}
export default authorizePage("order:edit")(withRouter(OrderInfo))